module.exports = __webpack_public_path__ + "components/pill/static/arrow-bbb7646b365e9422c092dacbcc68d6ff.svg";